import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkHOD, checkHOU } from '../../permission-utils/settings';
import { useSelector } from 'react-redux';

const RadiologyMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const staff = useSelector(state => state.user.profile);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/radiology/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/radiology">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li>
				<Link to="/radiology/new-request">
					<div className="icon-w">
						<div className="os-icon os-icon-plus-circle" />
					</div>
					<span>New Radiology</span>
				</Link>
			</li>
			{staff.role.slug !== 'front-desk' && (
				<>
					<li>
						<Link to="/radiology/categories">
							<div className="icon-w">
								<div className="os-icon os-icon-plus-circle" />
							</div>
							<span>Categories</span>
						</Link>
					</li>
					<li>
						<Link to="/radiology/resources">
							<div className="icon-w">
								<div className="os-icon os-icon-plus-circle" />
							</div>
							<span>Resources</span>
						</Link>
					</li>
				</>
			)}
			{isSupervisor && (
				<li>
					<Link to="/report/radiology">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Reports</span>
					</Link>
				</li>
			)}
		</>
	);
};

export default RadiologyMenu;
